import { ref } from "vue";

export const currentTimer = ref();
export const now = ref("加载中...");
export const currentTime = ref(new Date().getTime());
export const currentHours = ref(new Date().getHours() + 1);

/**
 * 获取当前时间
 */
export function getNow() {
  currentTimer.value = setInterval(() => {
    const date = new Date();
    currentTime.value = date.getTime();
    currentHours.value = date.getHours() + 1;
    const year = date.getFullYear(),
      month = (date.getMonth() + 1).toString().padStart(2, '0'),
      day = date.getDate().toString().padStart(2, '0'),
      // hours = date.getHours().toString().padStart(2, '0'),
      // minutes = date.getMinutes().toString().padStart(2, '0'),
      // seconds = date.getSeconds().toString().padStart(2, '0'),
      weekday = date.toLocaleDateString(undefined, { weekday: 'short' })
    // now.value = `${year}-${month}-${day} ${weekday} ${hours}:${minutes}:${seconds}`;
    now.value = `${year}-${month}-${day} ${weekday}`;
  }, 1000);
}